import React from "react";
import { EmptyStateContainer } from "./style";
import { NavLink } from "react-router-dom";

export const EmptyState = props => {
  return (
    <EmptyStateContainer
      marginTop={props.marginTop}
    >
      <div className="empty-state-main-container">
        {props.tabIcon && (
          <i className={`empty-state-tab-icon ${props.tabIcon}`} />
        )}
        <div className="empty-state-message-container">
          {props.children}
        </div>
        {props.link && (
          <NavLink to={props.link} className="empty-state-link">
            {props.linkText}
          </NavLink>
        )}
        {props.infoIcon && (
          <i
            className={`empty-state-info-icon ${props.infoIcon}`}
          />
        )}
      </div>
    </EmptyStateContainer>
  );
};
